interface IDataLayer {
  event: string
  eventAction: string
  eventCategory?: string
  eventLabel?: string
  eventUrl?: string
}

declare global {
  interface Window {
    dataLayer?: IDataLayer[]
  }
}

export function eventTracking(data: IDataLayer) {
  window.dataLayer?.push(data)
}
